export default class Review {
    constructor(id = '') {
        this.content = '';
        this.language = '';
        this.name = '';
        this.positive = true;
        this.createdAt = new Date();
        this.id = id;
    }
}
